// import external dependencies
import 'jquery';

// Import everything from autoload
import "./autoload/jquery.primarycolor.min.js"

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import nosotros from './routes/nosotros';
import clientes from './routes/clientes';
import contacto from './routes/contacto';

/** Populate Router instance with DOM routes */
const routes = new Router({
    common,
    home,
    nosotros,
    clientes,
    contacto,
});

function px(number) {
    return number + "px";
}

// Load Events
jQuery.fn.getSize = function() {
    return this[0].getBoundingClientRect();
};

jQuery.fn.translate3d = function(x, y, z) {
    var transform = "translate3d(" + x + ", " + y + ", " + z + ")";
    // Code for Safari
    this[0].style.WebkitTransform = transform;
    // Code for IE9
    this[0].style.msTransform = transform;
    // Standard syntax
    this[0].style.transform = transform;
};

jQuery.fn.setPosition = function(x, y) {
    return $(this).translate3d(px(x), px(y), 0);
};

jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js